import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Grid, Dropdown, Button, Icon, DropdownProps, DropdownItemProps } from 'semantic-ui-react';
import { ApplicationState, strings } from '../..';
import * as Archiviazione from '../';
import { FiltroArchivi } from '../models';

const connector = connect(
    (state: ApplicationState) => ({ 
        valoriFiltro: state.archivi.filtro, 
        lingua: state.core.lingua 
    }),
    Archiviazione.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

type FiltroProps = PropsFromRedux

type FiltroState = {
    idTipoDocumento: string,
    anno: string,
    mese: string
}

class Filtro extends React.Component<FiltroProps, FiltroState> {
    constructor(props: FiltroProps) {
        super(props);

        this.state = { 
            idTipoDocumento: '',
            anno: '',
            mese: ''
        };
    }

    componentDidMount() {
        this.props.loadArchiviazioneFiltro();
    }

    render() {
        return (                
            <Grid.Row>
                <Grid.Column mobile={6} tablet={6} computer={6}>
                    {this.renderDropdownTipiDocumento()}
                </Grid.Column>
                <Grid.Column width={3}>
                    {this.renderDropdownAnni()}
                </Grid.Column>
                <Grid.Column width={3}>
                    {this.renderDropdownMesi()}
                </Grid.Column>
                <Grid.Column width={3} textAlign='right'>
                    <Button primary onClick={this.onFiltraClick} style={{ width: 120 }}>
                        <Icon name='search' />
                        {strings.archivi.filtro.ricerca}
                    </Button>
                </Grid.Column>
            </Grid.Row>
        );
    }

    onFiltraClick = () => {
        const filtro: FiltroArchivi = 
        {
            idTipoDocumento: this.state.idTipoDocumento === '' ? undefined : this.state.idTipoDocumento,
            anno: this.state.anno === '' ? undefined : Number(this.state.anno),
            mese: this.state.mese === '' ? undefined : Number(this.state.mese),
            page: 1 
        };
        this.props.loadArchivi(filtro);
    }

    renderDropdownTipiDocumento = () => {
        const options = this.props.valoriFiltro.tipiDocumento
            .map(t => ({ key: t.idTipoDocumento, value: t.idTipoDocumento, text: t.tipoDocumento }));
        
        return (
            <Dropdown 
                placeholder={strings.archivi.filtro.tipoDocumento}
                clearable
                fluid
                options={options}
                selection
                onChange={this.onTipoDocumentoChanged}
            />
        );
    }

    renderDropdownAnni = () => {
        const options = this.props.valoriFiltro.anniConArchivi
            .map(a => ({ key: a.anno, value: a.anno, text: a.anno }));
        
        return (
            <Dropdown 
                placeholder={strings.archivi.filtro.anno}
                clearable
                fluid
                options={options}
                selection
                onChange={this.onAnnoChanged}
            />
        );
    }

    renderDropdownMesi = () => {
        let options: DropdownItemProps[] = [];        
        if (this.state.anno !== '') {
            const annoSelezionato = this.props.valoriFiltro.anniConArchivi.find(a => a.anno === Number(this.state.anno));
            options = annoSelezionato!.mesi
                .map(mese => ({ key: mese, value: mese, text: strings.archivi.filtro.mesi[mese - 1] }));
        }
        
        return (
            <Dropdown 
                placeholder={strings.archivi.filtro.mese}
                clearable
                fluid
                options={options}
                selection
                disabled={this.state.anno === ""}
                onChange={this.onMeseChanged}
            />
        );
    }

    onTipoDocumentoChanged = (_: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        this.setState({ idTipoDocumento: String(data.value) });
    }

    onAnnoChanged = (_: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
        const mese = data.value === '' ? '' : this.state.mese;

        this.setState({ anno: String(data.value), mese });
    }

    onMeseChanged = (_: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
        this.setState({ mese: String(data.value) });
    }
}

export default connector(Filtro);